import React from 'react';
import CountUp from 'react-countup';
import { FaServer, FaHeadset, FaRoute, FaGlobeAmericas } from 'react-icons/fa';

const numeros = [
  {
    valor: 26,
    sufixo: ' Datacenters/PIX',
    descricao: 'Conectividade em PIXs estratégicos',
    icone: <FaServer />
  },
  {
    valor: 24,
    sufixo: '/7',
    descricao: 'Suporte ininterrupto',
    icone: <FaHeadset />
  },
  {
    valor: 2000,
    sufixo: ' km',
    descricao: 'Fibra óptica lançada',
    icone: <FaRoute />
  },
  {
    valor: 5,
    sufixo: ' Saídas Internacionais',
    descricao: 'Conexões internacionais seguras',
    icone: <FaGlobeAmericas />
  }
];

export default function NossosNumeros() {
  return (
    <section className="section numeros" id="numeros">
      <div className="numeros-container">
        <h2>Nossos Números</h2>
        <div className="numeros-grid">
          {numeros.map((item, index) => (
            <div key={index} className="numero-card">
              <div className="numero-icone">{item.icone}</div>
              <div className="valor">
                <CountUp end={item.valor} duration={2} separator="." decimal=","/>{item.sufixo}
              </div>
              <div className="descricao">{item.descricao}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
